import React from 'react';

import { useStyles } from './Loader.styles';
import theme from '../../../styles/theme';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
  const { classes } = useStyles(theme);

  return (
    <div className={classes.loaderWrapper}>
      <CircularProgress color="primary" />
    </div>
  );
};

export default Loader;
